import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ListAllEmployeesForVenue$Params } from 'src/api/generated/fn/employee/list-all-employees-for-venue';
import { ListManagerEmployeesForVenue$Params } from 'src/api/generated/fn/employee/list-manager-employees-for-venue';
import { AddInventory$Params } from 'src/api/generated/fn/inventory/add-inventory';
import { GetInventory$Params } from 'src/api/generated/fn/inventory/get-inventory';
import { UpdateInventory$Params } from 'src/api/generated/fn/inventory/update-inventory';
import { AddInventoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Inventory/add-inventory-dto';
import { InventoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-dto';
import { UpdateInventoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Inventory/update-inventory-dto';
import { UserDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/User/user-dto';
import { EmployeeService, InventoryService } from 'src/api/generated/services';
import { RoleNameEnum } from 'src/app/admin-panel/enums/role-name.enum';
import { AuthenticationService } from 'src/app/share-modul/services/authentication/authentication.service';

@Component({
  selector: 'app-add-or-edit-inventory',
  templateUrl: './add-or-edit-inventory.component.html',
  styleUrls: ['./add-or-edit-inventory.component.scss']
})
export class AddOrEditInventoryComponent implements OnInit {

  venueId: string;
  companyId: string;
  selectedEmployees: Array<UserDto> = new Array<UserDto>();
  inventory: InventoryDto =  {} as InventoryDto;
  employees: Array<UserDto> = new Array<UserDto>();
  disableMainInventorySelection: boolean = false;
  
  constructor(private ref: DynamicDialogRef,
              private config: DynamicDialogConfig,
              private authenticationService: AuthenticationService,
              private employeeService: EmployeeService,
              private inventoryService: InventoryService) { 

    if (this.config.data != undefined) {
      
      if (this.config.data.venueId) {
        this.venueId = this.config.data.venueId;
      }
      
      if (this.config.data.inventoryId) {
        this.inventory.id = this.config.data.inventoryId;
        const params: GetInventory$Params = { inventoryId: this.config.data.inventoryId };
        this.inventoryService.getInventory(params).subscribe( response => this.inventory = response);
      }
      
      if (this.config.data.disableMain) {
        this.disableMainInventorySelection = this.config.data.disableMain;
      }
      this.authenticationService.loginUser.subscribe(user => {
        if(user?.roles.includes(RoleNameEnum.PosManager)){
          const params: ListAllEmployeesForVenue$Params = { VenueId: this.venueId }
          this.employeeService.listAllEmployeesForVenue(params).subscribe( response => {
            this.employees = response.map(e => {
              const em: UserDto = {id: e.userId, firstName: e.firstName, lastName: e.lastName}
              return em;
            });
          });
        }else{
          this.companyId = this.authenticationService.getCompanyId();
          const params: ListManagerEmployeesForVenue$Params = { VenueId: this.venueId, CompanyId: this.companyId };
          this.employeeService.listManagerEmployeesForVenue(params).subscribe( response => this.employees = response.users ? response.users : []);
        }
    });

      
    }
  }

  ngOnInit(): void {
  }

  save(f: NgForm){
    if(f.valid){
      if (this.inventory.id) {
        const updateInventory: UpdateInventoryDto = { isMain: this.inventory.isMain, 
                                                      managers: this.inventory.managers?.map((manager: any) => manager.userId ? manager.userId : manager.id  ) as Array<string>,
                                                      name: this.inventory.name};
        const params: UpdateInventory$Params = { inventoryId: this.inventory.id, body: updateInventory };
        this.inventoryService.updateInventory(params).subscribe({ next: response => this.ref.close(true), error: errorResponse => this.ref.close(errorResponse)});
      }else {
        const addInventory: AddInventoryDto = { isMain: this.inventory.isMain, 
                                                managers: this.inventory.managers?.map((manager: any) => manager.userId ? manager.userId : manager.id ) as Array<string>,
                                                name: this.inventory.name,
                                                venueId: this.venueId };
        const params: AddInventory$Params = { body: addInventory };
        this.inventoryService.addInventory(params).subscribe({ next: response => this.ref.close(true), error: errorResponse => this.ref.close(errorResponse)});
      }
    }
  }

  close(){
    this.ref.close(false);
  }

}
